import type { FaireProductEntity } from "../../entity_types/product";

export const p_dzsbf55zgn: FaireProductEntity = {
  token: "p_dzsbf55zgn",
  type: "product",
  name: "18K STAINLESS STEEL TARNISH FREE  RHINESTONE RINGS | 40R135",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/6f6d7b05c24e69648f87545ffd834ef5688292c39610a1ed5614c7a0780f70cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af818962202c35550dc422da0453121b51df0660771de99d0c6777c27edd09bb.jpeg",
    "https://cdn.faire.com/fastly/ca73859170e3e582d9144d98869567297b327c4227a688ee04c37c9aa493aa6b.jpeg",
    "https://cdn.faire.com/fastly/7bb0236dba8fb8e5b3ff65d2fa6529019d89fc85d912063e86bd4ef5f9a80cdc.jpeg",
    "https://cdn.faire.com/fastly/ef9ff156d3d88b0035cdcbeb6d6b546725173d1ddb773ab6d14b2fb45076df1a.jpeg",
    "https://cdn.faire.com/fastly/3238d8fd8fbf4285115b40fd82cff39b99c827a657479ec922f697fcfe510acf.jpeg",
    "https://cdn.faire.com/fastly/48f7d0881ff3535026e58867263e96d727fe595a80a80cefed080bba2e5bc59d.jpeg",
    "https://cdn.faire.com/fastly/2394ed0ba24e6ba4b553f6bb8965fa4f2272bbe626a5dbe46dee7d4bced1f9bc.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "18K Stainless Steel Tarnish-Free Rhinestone rings on stainless steel gold Ring are a stunning blend of high end luxury long lasting quality. Featuring shiny gold finish, a beautiful statement ring representing your personality. Durable, tarnish-free 18K gold-plated stainless steel. Each band consist of watch band inspired design.\n\nProduct detail:\nsize: 8\nmaterial:  Stainless Steel\nmetal finish: 18K Real Gold Dipped \nproduct: Lead & Nickel Compliant\ndurability: Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Ring\nStainless Steel Ring\nHypoallergenic Ring\nTarnish-Free Ring\nNon-Tarnish Ring\nWaterproof Ring\nWater Resistant Ring\nSweatproof Jewelry\nFade Resistant Ring\nAnti-oxidation \nLasting Shine \nPVD treated\n",
  tags: [],
  msrpDollars: 16.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:51.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
